module.exports = __webpack_public_path__ + "static/img/gather-home.7bdbd4af.jpg";